import { TreatmentRecord } from "@/types/care";

export interface TreatmentCategories {
  allPrescriptions: TreatmentRecord[];
  prescriptionsWithNoRefillsRemaining: TreatmentRecord[];
  prescriptionsWithRefillsRemaining: TreatmentRecord[];
  prescriptionsNotRefillable: TreatmentRecord[];
  alwaysRefillableTreatments: TreatmentRecord[];
}

/**
 * Categorizes treatments into different refill categories
 */
export function categorizeTreatments(
  treatments: TreatmentRecord[]
): TreatmentCategories {
  if (!treatments || treatments.length === 0) {
    return {
      allPrescriptions: [],
      prescriptionsWithNoRefillsRemaining: [],
      prescriptionsWithRefillsRemaining: [],
      prescriptionsNotRefillable: [],
      alwaysRefillableTreatments: [],
    };
  }

  const prescriptionsWithNoRefillsRemaining = treatments.filter(
    (prescription) =>
      prescription.is_refillable_product &&
      prescription.refills_remaining <= 0 &&
      !prescription.is_disabled_for_refill
  );

  const prescriptionsWithRefillsRemaining = treatments.filter(
    (prescription) =>
      !prescription.is_otc_product &&
      prescription.is_refillable_product &&
      prescription.refills_remaining > 0 &&
      !prescription.is_disabled_for_refill
  );

  const prescriptionsNotRefillable = treatments.filter(
    (prescription) =>
      prescription.is_disabled_for_refill ||
      (!prescription.is_refillable_product && !prescription.is_otc_product)
  );

  const alwaysRefillableTreatments = treatments.filter(
    (prescription) =>
      prescription.is_otc_product && !prescription.is_disabled_for_refill
  );

  return {
    allPrescriptions: treatments,
    prescriptionsWithNoRefillsRemaining,
    prescriptionsWithRefillsRemaining,
    prescriptionsNotRefillable,
    alwaysRefillableTreatments,
  };
}

/**
 * Finds a prescription by product slug
 */
export function findPrescriptionBySlug(
  treatments: TreatmentRecord[],
  slug: string
): TreatmentRecord["product"] | undefined {
  return treatments.find((prescription) => prescription?.product.slug === slug)
    ?.product;
}
